import { render, staticRenderFns } from "./dialog-create-notice.vue?vue&type=template&id=20deae5e&scoped=true"
import script from "./dialog-create-notice.vue?vue&type=script&lang=js"
export * from "./dialog-create-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20deae5e",
  null
  
)

export default component.exports